@file:OptIn(ExperimentalBlockRichTextApi::class)

package com.taocent.simple.compose.component.blockrichtext.internal.block.renderer

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.IntOffset
import androidx.compose.ui.unit.dp
import androidx.compose.ui.zIndex
import com.taocent.simple.compose.component.blockrichtext.ExperimentalBlockRichTextApi
import com.taocent.simple.compose.component.richtext.core.TableConfig
import kotlin.math.roundToInt

/**
 * 独立的行按钮 Composable,隔离行按钮的重组范围。
 * 抽离自 `TableRenderer.kt`,通过参数接收所有需要的输入。
 */
@Composable
internal fun TableRowButton(
    menuButtonSize: Dp,
    tableConfig: TableConfig,
    rowOffset: Float,
    rowHeightDp: Dp,
    isRowLifted: Boolean,
    showRowButton: Boolean,
    isSelectedRow: Boolean,
    showRowMenu: Boolean,
    dragGestureModifier: Modifier,
    onRowClick: () -> Unit,
    onInsertAbove: () -> Unit,
    onInsertBelow: () -> Unit,
    onInsertTableAbove: () -> Unit,
    onDeleteRow: () -> Unit,
    onDeleteTable: () -> Unit,
    onDismissMenu: () -> Unit,
) {
    Box(
        modifier = Modifier
            .zIndex(if (isRowLifted) 1f else 0f)
            .width(menuButtonSize)
            .then(if (rowHeightDp > 0.dp) Modifier.height(rowHeightDp) else Modifier.heightIn(min = tableConfig.cellMinHeight))
            .offset { IntOffset(0, rowOffset.roundToInt()) }
            .then(if (showRowButton) dragGestureModifier else Modifier),
        contentAlignment = Alignment.Center
    ) {
        if (showRowButton) {
            ThreeDotsButton(
                horizontal = false,
                modifier = Modifier.size(menuButtonSize),
                onClick = onRowClick
            )
            RowMenu(
                expanded = showRowMenu && isSelectedRow,
                onDismiss = onDismissMenu,
                onInsertAbove = onInsertAbove,
                onInsertBelow = onInsertBelow,
                onInsertTableAbove = onInsertTableAbove,
                onDelete = onDeleteRow,
                onDeleteTable = onDeleteTable
            )
        }
    }
}
